/**
 * Retrieves the list of available languages.
 * @returns {Array<Object>} An array of language objects containing id, code, and value.
 */
export function getLangsList() {
    return langs;
}

// Array of language objects with their respective identifiers, codes, and names.
const langs = [
    { id: 'en', code: 'US', value: 'English' },
    /*{ id:"zh", code:"CN", value:"中文" },*/ // Chinese language entry (commented out)
    { id: 'es', code: 'ES', value: 'Español' },
    { id: 'pt', code: 'ES', value: 'Portugués' },
    /*{ id:"ko", code:"KR", value:"한국어" }, // Korean language entry (commented out)
	{ id:"ru", code:"RU", value:"Русский" }, // Russian language entry (commented out)
	{ id:"de", code:"DE", value:"Deutsch" } // German language entry (commented out) */
];

// FILE DOCUMENTED
